import { Link } from 'react-router-dom'
import { Header } from '../components/Header.jsx'
import { getViewData } from './MenuView'
import projectsData from '../data/projects.json'

export const AllProjectsView = () => {
  const viewData = getViewData('projects')

  return (
    <>
      <Header
        title={viewData.title}
        icon={viewData.icon}
        description={viewData.description}
      />
      <div className='projects_all_container'>
        {projectsData.data.map((project) => (
          <Link
            to={`/index/projects/${project.slug}`}
            className='project'
            key={project.slug}>
            <div className='cards-stacked'>
              {project.screenshots.length ? (
                <>
                  {project.screenshots
                    .filter((_image, index) => index < 3)
                    .map((image, index) => (
                      <div
                        style={{
                          backgroundImage: `url(${image})`
                        }}
                        key={index}
                      />
                    ))}
                </>
              ) : (
                <>
                  <div>
                    <h3>(Screenshots unavailable)</h3>
                  </div>
                  <div />
                  <div />
                </>
              )}
            </div>
            <div>
              <h2>{project.name}</h2>
              <p>{project.description}</p>
              <div className='go_to'>
                <span>View project</span>
                <span className='material-symbols-rounded'>
                  arrow_right_alt
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </>
  )
}
